// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-42ba43b7d5dcb1e3.js";
	if (chunkId === 850) return "static/chunks/850-6886274a4de7f73c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"15":"4309dee8d9706ce4","163":"e0d9734c538e1688","819":"84debd99d1206b39"}[chunkId] + ".js";
};